import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { AppConstants } from '../../app.constants';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { FormsModule } from '@angular/forms';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
 

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    LayoutModule,
    IconsModule,
    InputsModule,
    LabelModule,
    ButtonsModule,
    DropDownsModule, RouterOutlet, HeaderComponent],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent {
  public appConstants = AppConstants;
    constructor(
      private router: Router,
    
    ) { }


 public navigateTabs(event: { title: string }) {
    switch (event.title) {
      case AppConstants.HomeLabel:
        this.router.navigateByUrl('/Home');
        break;
      case AppConstants.OperationsReportLabel:
        this.router.navigateByUrl('/OperationsReport');
        console.log('url ===================>', this.router.url)
        break;
      case AppConstants.OTBookingLabel:
        console.log("test navigate",this.router)
        this.router.navigateByUrl('/OTBooking');
        break;
      case AppConstants.HolidayManagementLabel:
        this.router.navigateByUrl('/Holiday');
        break;
      case AppConstants.ESubCheckListLabel:
        this.router.navigateByUrl('/ESubCheckList');
        break;
    }
  }
  public handleMenuActiveClass(routerLink: string): boolean {
    return this.router.url.includes(routerLink);
  }
}
